import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface VacancyRateChartProps {
  data: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string;
      borderColor: string;
      borderWidth: number;
    }[];
  };
}

const VacancyRateChart: React.FC<VacancyRateChartProps> = ({ data }) => {
  const lightColors = [
    '#4285F4', // Normal Blue
    '#DB4437', // Normal Red
    '#0F9D58', // Normal Green
  ];

  const updatedDatasets = data.datasets.map((dataset, index) => ({
    ...dataset,
    backgroundColor: lightColors[index % lightColors.length],
    borderColor: lightColors[index % lightColors.length],
  }));

  const chartData = {
    labels: data.labels,
    datasets: updatedDatasets,
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
        labels: {
          color: '#586069', // GitHub-like text color
        },
      },
      title: {
        display: true,
        text: 'Vacancy Rate Trends',
        color: '#586069', // GitHub-like text color
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 1 }).format(context.parsed.y / 100);
            }
            return label;
          }
        }
      }
    },
    scales: {
      x: {
        ticks: {
          color: '#586069', // GitHub-like text color
        },
        grid: {
          color: 'rgba(100, 100, 100, 0.2)', // GitHub-like grid color
        },
      },
      y: {
        ticks: {
          color: '#586069', // GitHub-like text color
          callback: function(value: any) {
            return new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 0 }).format(value / 100);
          }
        },
        grid: {
          color: 'rgba(100, 100, 100, 0.2)', // GitHub-like grid color
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default VacancyRateChart;